<template>
    <div class="row no-gutters h-100">
        <div class="col-md-9 col-12">
            <div id="map" ref="map"></div>
        </div>
        <div class="col-md-3 d-md-block d-none">
            <div class="p-2">
                <app-timeline>
                    <app-timeline-item time="" :title="route.origin" subtitle="Başlangıç" icon="MapPinIcon" variant="primary"/>
                    <app-timeline-item time="" v-for="(waypoint,index) in route.waypoints" :key="index" :title="waypoint" subtitle="Durak" icon="MapPinIcon" variant="primary"/>
                    <app-timeline-item time="" :title="route.destination" subtitle="Varış" icon="MapPinIcon" variant="primary"/>
                </app-timeline>
            </div>
        </div>
    </div>
</template>

<script>
import GoogleMaps from '@/utilities/google-maps';
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'

export default {
    components:{
        AppTimeline,
        AppTimelineItem,
    },
    props:{
        route:{
            type:Object,
            required:true
        }
    },
    mounted(){
        const google = new GoogleMaps()
        google.RenderMapWithRoute(
            this.$refs.map,
            this.route.origin,
            this.route.destination,
            this.route.waypoints,
            this.route.avoidHighways,
            this.route.avoidTolls,
        )
    }
}
</script>

<style>
    #map {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
    }
</style>